import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
//import IMAGES from '../images';
import './Hero.css';

//import { douches, robinetsAPoser } from '../data/robinetterie';
//import { vasquesMarbre, vasquesLaiton } from '../data/vasques';

const SLIDES = [
  {
    img: 'https://khansayazidi.tn/assets/Robinetterie/robinets%20%c3%a0%20poser/Robinet%20%c3%a0%20poser%20Olea%20Aurea/DSC07184.webp' || '',
    label: 'Robinetterie Artisanale',
    title: ['Façonné', 'à la main'],
    italic: true,
    cta: 'Explorer',
    link: '/robinetterie',
  },
  {
    img: 'https://khansayazidi.tn/assets/Vasques/Vasques%20en%20laiton%20martel%c3%a9/Vaque%20%c3%a0%20poser%20anneaux/1779030091566.webp' || '',
    label: 'Vasques Nobles',
    title: ['Marbre & Laiton', 'Matières Vivantes'],
    italic: true,
    cta: 'Voir les Vasques',
    link: '/vasques',
  },
  {
    img: 'https://khansayazidi.tn/assets/Accessoires/Porte-serviettes/distributeur%20de%20serviettes%20de%20bain%20Houta/distributeur_serviettes_bain.webp' || '',
    label: 'Accessoires',
    title: ['Matières', 'd\'Exception'],
    italic: true,
    cta: 'Nos Accessoires',
    link: '/accessoires',
  },
  {
    img: 'https://khansayazidi.tn/assets/Nos%20cr%c3%a9ations%20chez%20vous/Salle%20eau%20H.%20-%20La%20Soukra/IMG_3414.webp' || '',
    label: 'Des espaces distingués',
    title: ['Nos Créations', 'Chez Vous'],
    italic: true,
    cta: 'Vos Espaces',
    link: '/creations',
  },
];

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const goTo = (index) => {
    if (transitioning || index === current) return;
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(index);
      setTransitioning(false);
    }, 400);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      goTo((current + 1) % SLIDES.length);
    }, 5500);
    return () => clearInterval(interval);
  }, [current, transitioning]);

  const slide = SLIDES[current];

  return (
    <section className="hero">
      {/* Background images preloaded */}
      {SLIDES.map((s, i) => (
        <div
          key={i}
          className={`hero__bg ${i === current ? 'hero__bg--active' : ''}`}
          style={{ backgroundImage: `url("${s.img}")` }}
        />
      ))}

      {/* Overlay */}
      <div className="hero__overlay" />

      {/* Content */}
      <div className={`hero__content ${transitioning ? 'hero__content--out' : 'hero__content--in'}`}>
        <span className="hero__label">{slide.label}</span>
        <h1 className="hero__title">
          {slide.title[0]}
          {slide.title[1] && (
            <>
              <br />
              <em>{slide.title[1]}</em>
            </>
          )}
        </h1>
        <Link to={slide.link} className="hero__btn">
          {slide.cta}
        </Link>
      </div>

      {/* Slide indicators */}
      <div className="hero__indicators">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            className={`hero__dot ${i === current ? 'hero__dot--active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      {/* Progress bar */}
      <div className="hero__progress">
        <div key={current} className="hero__progress-bar" />
      </div>

      {/* Scroll cue */}
      <div className="hero__scroll">
        <span>Défiler</span>
        <div className="hero__scroll-line" />
      </div>
    </section>
  );
}
